// extracted by mini-css-extract-plugin
export default {"imageWrapper":"OP-z","hovered":"PP-z","hoverImage":"QP-z","mainImage":"RP-z","imageNoBackground":"SP-z","fullSizeImage":"TP-z"};